/**
 * Duck-typing for Jira error detection (TanStack Query may wrap errors)
 */
interface JiraErrorDetails {
  detail?: { error?: string };
}

/**
 * Check if error indicates Jira reconnection is required (token expired/revoked)
 */
export function isJiraReconnectRequired(error: unknown): boolean {
  const apiError = error as { details?: JiraErrorDetails; status?: number } | null;
  if (!apiError) return false;
  return apiError.status === 401 && apiError.details?.detail?.error === 'reconnect_required';
}
